import React from 'react'
import * as Styled from './styled'
import { IProps } from './types'

const ActiveAsideOverlay: React.FC<IProps> = ({ children, className }) => {
  return (
    <Styled.OverlayContainer className={className}>
      <Styled.Content>{children}</Styled.Content>
    </Styled.OverlayContainer>
  )
}

export default ActiveAsideOverlay
